/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import useForm from '../../hooks/useForm';
import Modal, { ModalHeader } from '../Modal';
import Form from '../Form';
import { MEMBERSHIP_TARGET_TYPE } from '../../constants/MEMBERSHIP';
import { addMembership, editMembership } from '../../apis/membership';
import { toast } from '../../utils/toast';
const defaultForm = {
  targetType: MEMBERSHIP_TARGET_TYPE[0].value,
  level: "",
  isEnable: "1"
};
const Membership = ({ open, setOpen, selectedItem, setSelectedItem, submit }) => {
  const [fields] = useState([
    [{
      title: "대상",
      type: "select",
      key: "targetType",
      options: {
        list: MEMBERSHIP_TARGET_TYPE
      }
    }],
    [
      {
        title: "등급명",
        type: "input",
        key: "label",
      },
      {
        title: "등급",
        type: "input",
        key: "level",
      }
    ],
    [
      {
        title: "사용여부",
        type: "radio",
        key: "isEnable",
        options: {
          list: [
            { label: "사용", value: "1", },
            { label: "미사용", value: "0" }
          ]
        }
      }
    ]

  ]);
  const [mode, setMode] = useState("create");
  const close = (e) => {
    if (e) {
      e.preventDefault();
    }
    setSelectedItem(null);
    setOpen(false);
    submit && submit();
  };

  const _submit = (_form) => {
    const form = {
      ..._form,
      isEnalbe: _form.isEnable === "1" ? true : false,
    };

    if (mode === "create") {
      addMembership(form)
        .then(res => {
          toast.success("멤버십 등급이 등록되었습니다.");
          close();
        });
    } else {
      editMembership(selectedItem.idx, form)
        .then(res => {
          toast.success("멤버십 등급이 수정되었습니다.");
          close();
        });
    }
  };

  const {
    form,
    errors,
    setForm,
    handleOnChange,
    handleSubmit,
    setOriginForm,
  } = useForm(
    defaultForm,
    _submit,
    fields
  );


  useEffect(() => {
    setMode(selectedItem ? 'modify' : 'create');
    if (selectedItem) {
      setForm({
        ...selectedItem,
        isEnable: selectedItem.isEnable ? "1" : "0"
      });
      setOriginForm({
        ...selectedItem,
        isEnable: selectedItem.isEnable ? "1" : "0"
      });
    } else {
      setForm(defaultForm);
      setOriginForm(defaultForm);
    }

  }, [open, selectedItem]);


  return (
    <>
      <Modal
        isOpen={open}
        toggle={close}
      >

        <ModalHeader>
          {`멤버십 등급 ${mode === "create" ? "등록" : "수정"}`}
        </ModalHeader>
        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={mode === "create" ? "등록" : "수정"}
          submit={handleSubmit}
          cancel={close}
        />
      </Modal>
    </>
  );
};

export default Membership;